/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function joinURL() {
  var url = arguments[0];
  for (var i = 1; i < arguments.length; ++i) {
    url = url.replace(/\/$/, '') + '/' + arguments[i].replace(/^\//, ''); //eslint-disable-line prefer-template
  }
  return url;
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLocal;
/**
 * @param {string} path
 * @returns {boolean}
 */
function isLocal(path) {
  return (/^(https?:)?\/\/localhost($|[/:])/.test(path)
  );
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bareSemver = /(\d)+\.(\d)+\.(\d)+/;
var onlyBareSemver = /^(\d)+\.(\d)+\.(\d)+$/;
var onlySha = /^[0-9a-f]{40}$/;

var validVersion = function validVersion(version) {
  return onlyBareSemver.test(version) || onlySha.test(version);
};

function replaceUrlVersion(url, version) {
  return url && validVersion(version) ? url.replace(bareSemver, version) : url;
}

exports.default = replaceUrlVersion;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PackagesUtil = __webpack_require__(5);

var _PackagesUtil2 = _interopRequireDefault(_PackagesUtil);

var _addExperimentsFromQuery = __webpack_require__(7);

var _addExperimentsFromQuery2 = _interopRequireDefault(_addExperimentsFromQuery);

var _getBaseVersion = __webpack_require__(8);

var _getFullRjsConfig = __webpack_require__(9);

var _getFullRjsConfig2 = _interopRequireDefault(_getFullRjsConfig);

var _getQueryUtils = __webpack_require__(10);

var _getQueryUtils2 = _interopRequireDefault(_getQueryUtils);

var _getSubdomain = __webpack_require__(11);

var _getSubdomain2 = _interopRequireDefault(_getSubdomain);

var _identifyForFullStory = __webpack_require__(12);

var _identifyForFullStory2 = _interopRequireDefault(_identifyForFullStory);

var _instrument = __webpack_require__(13);

var _instrument2 = _interopRequireDefault(_instrument);

var _isLocal = __webpack_require__(1);

var _isLocal2 = _interopRequireDefault(_isLocal);

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

var _overrideScriptsLocationMapFromQuery = __webpack_require__(14);

var _overrideScriptsLocationMapFromQuery2 = _interopRequireDefault(_overrideScriptsLocationMapFromQuery);

var _replaceUrlVersion = __webpack_require__(2);

var _replaceUrlVersion2 = _interopRequireDefault(_replaceUrlVersion);

var _requirejs = __webpack_require__(15);

var _requirejs2 = _interopRequireDefault(_requirejs);

var _rjsConfig = __webpack_require__(16);

var _rjsConfig2 = _interopRequireDefault(_rjsConfig);

var _runEditor = __webpack_require__(19);

var _runEditor2 = _interopRequireDefault(_runEditor);

var _storageUtil = __webpack_require__(20);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window,getPloaderSantaConfig */

var options = __webpack_require__(21);

var queryUtil = (0, _getQueryUtils2.default)(window);

window.joinURL = _joinURL2.default;
window.queryUtil = queryUtil;
window.persistent = (0, _storageUtil2.default)(window); // TODO: how is this used?
window.identifyForFullStory = _identifyForFullStory2.default;

if (window.customRenderSite !== undefined) {
  // allows to override this in other html files as starting points
  window.customRenderSite();
} else {
  render();
}

function render() {
  var local = (0, _isLocal2.default)(queryUtil.getParameterByName('EditorSource'));
  var getEditorRjsConfig = (0, _rjsConfig2.default)(window, options.versions, getPloaderSantaConfig, local);
  var packagesUtil = new _PackagesUtil2.default(options.packages, window.location.search);

  window.mainLoaded = Date.now();

  window.serviceTopology.mediaManagerUrl = (0, _replaceUrlVersion2.default)(window.serviceTopology.mediaManagerUrl, queryUtil.getParameterByName('mmgr'));
  window.serviceTopology.scriptsLocationMap = (0, _overrideScriptsLocationMapFromQuery2.default)(window.serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'));

  var editorModel = window.editorModel;
  if (editorModel) {
    editorModel.runningExperiments = (0, _addExperimentsFromQuery2.default)(editorModel.runningExperiments, queryUtil, 'editor');
    editorModel.languageCode = queryUtil.getParameterByName('lang') || editorModel.languageCode;
  }

  var config = (0, _getFullRjsConfig2.default)('santa-editor', window.editorBase, getEditorRjsConfig(window.serviceTopology, editorModel, window.santaBase, _PackagesUtil2.default), packagesUtil, window.serviceTopology);

  if (editorModel) {
    editorModel.editorBase = config.baseUrl;
    editorModel.editorVersion = (0, _getBaseVersion.getBaseVersion)(config.baseUrl);

    (0, _instrument2.default)(window, _requirejs2.default, queryUtil, editorModel);
    window.bi.event(458, { // main-r loaded event
      prefetch: window.afterEditorPrefetch
    });
  } else {
    (0, _instrument2.default)(window, _requirejs2.default, queryUtil);
  }

  _requirejs2.default.config(config);

  try {
    window.document.domain = (0, _getSubdomain2.default)(window.document.domain);
  } catch (e) {
    // empty
  }

  if ((0, _isLocal2.default)(window.editorBase) && queryUtil.getParameterByName('hot') !== 'false') {
    (0, _requirejs2.default)(['hot', 'jquery'], function (hot, $) {
      hot.init($, false);
      (0, _runEditor2.default)(window, options.packages, _requirejs2.default, editorModel, queryUtil, config);
    });
  } else {
    (0, _runEditor2.default)(window, options.packages, _requirejs2.default, editorModel, queryUtil, config);
  }
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reduceQueryToObject = __webpack_require__(6);

var _reduceQueryToObject2 = _interopRequireDefault(_reduceQueryToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Array.<string>} packagesStructure
 * @param {string} query
 * @param {Array.<string>?} bundles
 * @constructor
 */
function PackagesUtil(packagesStructure, query) {
  var bundles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var queryParamsObject = (0, _reduceQueryToObject2.default)(query.replace(/^\?/, ''));

  /**
   * changes the config to load packages correctly, accounting the query
   * @param {Object} config
   * @returns {Object}
   */
  this.buildConfig = function (config) {
    var debug = (decodeURIComponent(queryParamsObject.debug) || '').split(',').filter(Boolean);

    if (debug.indexOf('all') !== -1) {
      var debuggableExternals = Object.keys(config.paths).filter(function (path) {
        return config.paths[path].source;
      });
      debug = packagesStructure.concat(debuggableExternals);
    }

    function isInDebug(i) {
      return debug.indexOf(i) !== -1;
    }

    //config.paths:
    Object.keys(config.paths).filter(function (k) {
      return _typeof(config.paths[k]) === 'object' && !Array.isArray(config.paths[k]);
    }).forEach(function (k) {
      config.paths[k] = config.paths[k][isInDebug(k) ? 'source' : 'min'];
    });

    //config.bundles:
    config.bundles = config.bundles || {};

    packagesStructure.filter(function (p) {
      return !isInDebug(p);
    }).filter(function (p) {
      return bundles.indexOf(p) === -1;
    }).forEach(function (pkg) {
      config.bundles[pkg] = pkg;
      config.paths[pkg] = 'packages-bin/' + pkg + '/' + pkg + '.min';
    });

    if (bundles && bundles.length > 0) {
      var bundleName = 'first-load';
      config.bundles[bundleName] = bundles;
      config.paths[bundleName] = 'packages-bin/' + bundleName + '/' + bundleName + '.min';
    }

    //config.packages:
    config.packages = config.packages || [];
    var projectPackages = packagesStructure.filter(isInDebug).map(function (name) {
      return {
        name: name,
        location: 'packages/' + name + '/src/main',
        main: name
      };
    });
    config.packages = config.packages.concat(projectPackages);

    return config;
  };
}

exports.default = PackagesUtil;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduceQueryToObject;
/**
 *
 * @param {string} str
 * @param {string?} separator
 * @param {string?} equalizer
 * @returns {*}
 */
function reduceQueryToObject(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
  var equalizer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';

  return (str || '').replace(/^\?/, '').split(separator).reduce(function (o, pairString) {
    var pair = pairString.split(equalizer);
    o[pair[0]] = pair[1];
    return o;
  }, {});
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = addExperimentsFromQuery;
function addExperimentsFromQuery(runningExperiments, queryUtil, project) {
  var projValuePairRegex = new RegExp('^(' + project + ':)(.*)|(.*)$');

  var experiments = {};
  Object.keys(runningExperiments).forEach(function (key) {
    experiments[key] = runningExperiments[key];
  });

  var setPair = function setPair(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    experiments[key] = value;
  };
  var getValueIfProj = function getValueIfProj(str) {
    return str.replace(projValuePairRegex, '$2');
  };

  var filterParamsForCurrProj = function filterParamsForCurrProj(paramValue) {
    return paramValue.split(';').map(getValueIfProj).filter(Boolean).join(',');
  };

  var setParamValues = function setParamValues(param, value) {
    var paramValue = queryUtil.getParameterByName(param);
    if (paramValue.indexOf(':') !== -1) {
      // Should be deprecated
      paramValue = filterParamsForCurrProj(paramValue);
    }
    paramValue.split(',').filter(Boolean).map(function (exp) {
      return [exp, value];
    }).forEach(setPair);
  };

  var setProjParamExperiments = function setProjParamExperiments() {
    queryUtil.getParameterByName(project + 'exp').split(',').filter(Boolean).map(function (exp) {
      return exp.split(':');
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return [key.toLowerCase(), value || 'new'];
    }).forEach(setPair);
  };

  //////////////////

  setParamValues('experiments', 'new');
  setParamValues('experimentsoff', 'old');
  setProjParamExperiments();

  return experiments;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param url
 * @returns {*|Array|{index: number, input: string}}
 */
function getBaseVersion(url) {
  var semverMatches = url.match(/\/(\d+\.\d+\.\d+)\/?$/);
  return semverMatches && semverMatches[1];
}

exports.getBaseVersion = getBaseVersion;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFullRjsConfig;

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAddress = function isAddress(str) {
  return (/^(https?:)?\/\//.test(str)
  );
}; /* eslint curly:0 */

function getFullRjsConfig(name, base, config, packagesUtil, serviceTopology) {
  function getBaseUrl() {
    if (!base) return serviceTopology.scriptsLocationMap[name];
    if (isAddress(base)) return base;
    return (0, _joinURL2.default)(serviceTopology.scriptsDomainUrl, 'services', name, base);
  }

  config = packagesUtil.buildConfig(config);
  config.baseUrl = getBaseUrl();
  return config;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryUtils;
/**
 * Get value of URL parameter by its name
 * @param {string} name
 * @param {string} query
 * @returns {string}
 */
function getParameterFromQuery(query, name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(query);
  return results && results[1] ? decodeURIComponent(results[1]).replace(/\+/g, ' ') : '';
}

/**
 * Get state of boolean URL parameter by its name
 * @param {string} name
 * @param {string} query
 * @returns {boolean}
 */
function isParameterTrueInQuery(query, name) {
  return getParameterFromQuery(query, name) === 'true';
}

function getQueryUtils(window) {
  return {
    getParameterFromQuery: getParameterFromQuery,
    isParameterTrueInQuery: isParameterTrueInQuery,
    getParameterByName: getParameterFromQuery.bind(null, window.location.search),
    isParameterTrue: isParameterTrueInQuery.bind(null, window.location.search)
  };
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint prefer-template:0 */

module.exports = function getSubdomain(domain) {
  if (!domain) {
    return '';
  }
  var subDomain = domain.split('.');
  if (subDomain.length <= 2) {
    subDomain = domain;
  } else {
    var beforeLastPart = subDomain[subDomain.length - 2];
    var topLevelDomains = { com: true, org: true, net: true, edu: true, gov: true, mil: true, info: true, co: true, ac: true };
    if (topLevelDomains[beforeLastPart]) {
      subDomain = subDomain[subDomain.length - 3] + '.' + subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
    } else {
      subDomain = subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
    }
  }
  return subDomain;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = identifyForFullStory;
/* globals window */

function identifyForFullStory(fullStory, editorModel) {
  fullStory.identify(editorModel.editorSessionId, {
    userId: editorModel.permissionsInfo.loggedInUserId,
    userAgent: window.navigator.userAgent,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width
  });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = instrument;
function instrument(window, requirejs, queryUtil, editorModel) {
  editorModel = editorModel || {};

  var editorVersion = editorModel.editorVersion;
  var base = (window.serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '');
  var suppressbi = queryUtil.isParameterTrue('suppressbi');
  var isDebug = queryUtil.getParameterByName('debug');

  var storage = function () {
    // TODO replace with storage utils
    try {
      var s = window.sessionStorage;
      var test = 'ep' + Date.now();
      s.setItem(test, test);
      if (s.getItem(test) === test) {
        s.removeItem(test);
        return s;
      }
    } catch (e) {
      var data = {};
      return {
        setItem: function setItem(k, v) {
          data[k] = v;
        },
        getItem: function getItem(k) {
          return data[k];
        },
        removeItem: function removeItem(k) {
          delete data[k];
        }
      };
    }
  }();
  if (window.isPrefetchMode) {
    storage.setItem('afterEditorPrefetch', 'true');
  } else {
    window.afterEditorPrefetch = !!storage.getItem('afterEditorPrefetch');
    storage.removeItem('afterEditorPrefetch');
  }

  var performance = window.performance;
  if (performance && performance.mark) {
    if (performance.setResourceTimingBufferSize) {
      if ('onresourcetimingbufferfull' in performance) {
        performance.onresourcetimingbufferfull = function () {
          var maxSize = 150;
          return function () {
            maxSize *= 2;
            performance.setResourceTimingBufferSize(maxSize);
          };
        }();
      } else {
        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300);
      }
    }
    performance.mark('main-r loaded');
  }

  function getCookie(name) {
    var re = new RegExp('(?:^|\\W)' + name + 's*=([^;]*)');
    var m = window.document.cookie.match(re);
    return m ? m[1].trim() : m;
  }

  var permissionInfo = editorModel.permissionsInfo || {};
  var implicitParams = function () {
    var implicitFields = {
      ownerId: function ownerId() {
        return permissionInfo.ownerId || '';
      },
      roles: function roles() {
        var loggedInUserRoles = (permissionInfo.loggedInUserRoles || []).map(function (loggedInUserRole) {
          return loggedInUserRole.role;
        }).join();
        this.roles = function () {
          return loggedInUserRoles;
        };
        return this.roles();
      },
      esi: function esi() {
        return editorModel.editorSessionId || '';
      },
      did: function did() {
        return window.siteId || '';
      },
      msid: function msid() {
        return editorModel.metaSiteId || '';
      },
      ts: function ts(now) {
        return now - (window.mainLoaded || 0);
      },
      c: function c(now) {
        return now;
      }
    };

    var newrelic = window.newrelic;
    if (newrelic) {
      if (newrelic.setCustomAttribute) {
        newrelic.setPageViewName(window.location.href.replace(/^[^/]*\/\//, ''));

        var roles = implicitFields.roles();
        if (roles) {
          newrelic.setCustomAttribute('roles', roles);
        }
        newrelic.setCustomAttribute('esi', implicitFields.esi());
        newrelic.setCustomAttribute('did', implicitFields.did());
        newrelic.setCustomAttribute('msid', implicitFields.msid());
        newrelic.setCustomAttribute('prefetch', window.afterEditorPrefetch);
        if (editorVersion) {
          newrelic.setCustomAttribute('editorVersion', editorVersion);
        }

        // Running experiments:
        var runningExperiments = editorModel.runningExperiments;
        if (runningExperiments) {
          var runningExperimentKeys = Object.keys(runningExperiments).filter(function (key) {
            return runningExperiments[key] !== 'old';
          }).map(function (experimentName) {
            var experimentValue = runningExperiments[experimentName];
            return experimentValue !== 'new' ? experimentName + '=' + experimentValue : experimentName; //eslint-disable-line prefer-template
          }).join('][');
          if (runningExperimentKeys) {
            newrelic.setCustomAttribute('experiments', '[' + runningExperimentKeys + ']');
          }
        }
      }
      if (!suppressbi && editorVersion && newrelic.addPageAction) {
        newrelic.addPageAction('main-r loaded');
      }
    }

    return function () {
      var size = 0;
      var now = Date.now();
      var payload = Object.keys(implicitFields).map(function (key) {
        var val = implicitFields[key](now);
        var result = key + '=' + val;
        size += result.length;
        return result;
      });
      payload.size = size;
      return payload;
    };
  }();

  function sendBI(reportDef, params) {
    var payload = implicitParams();

    var size = payload.size;
    params = Object.keys(params || {}).map(function (key) {
      var value = params[key];
      if (typeof value === 'string') {
        if (size + value.length > 1536) {
          value = value.substring(0, Math.max(1536 - size, 32));
        }
        value = encodeURIComponent(value);
      }
      var result = key + '=' + value;
      size += result.length;
      return result;
    });
    payload = params.concat(payload);

    var endpoint = reportDef.endpoint || 'editor';
    var evid = reportDef.evid;
    var src = reportDef.src || 38;
    payload = payload.length ? '&' + payload.join('&') : ''; //eslint-disable-line prefer-template

    var srcBI = base + '/' + endpoint + '?evid=' + evid + '&src=' + src + '&majorVer=3&viewMode=editor' + payload;
    if (suppressbi) {
      window.console.log('BI:', srcBI);
    } else {
      new window.Image().src = srcBI;
    }
  }

  var bi = {
    event: function event(reportDef, params) {
      if (typeof reportDef === 'number') {
        reportDef = { evid: reportDef };
      }
      sendBI(reportDef, params);
    },

    error: function () {
      var errorSeverityMap = {
        recoverable: 10,
        warning: 20,
        error: 30,
        fatal: 40
      };
      return function (reportDef, params) {
        params = params || {};
        var rd = {
          evid: 10,
          endpoint: reportDef.endpoint || 'trg'
        };
        var p = {
          errn: reportDef.errorName,
          errc: reportDef.errorCode,
          sev: errorSeverityMap[reportDef.severity] || reportDef.severity,
          cat: 1,
          iss: 1
        };
        var ut = getCookie('userType');
        if (ut) {
          p.ut = ut;
        }
        Object.keys(params).forEach(function (param) {
          p[param] = params[param];
        });
        sendBI(rd, p);
      };
    }()
  };
  window.bi = bi;

  if ((isDebug || suppressbi || !editorVersion) && !queryUtil.isParameterTrue('bi')) {
    return;
  }

  var _sendErrorOnce = function sendErrorOnce(errorName, errorCode, severity) {
    //eslint-disable-line func-style
    _sendErrorOnce = function sendErrorOnce() {}; // only report one error per session
    var params = Array.prototype.slice.call(arguments, 3).reduce(function (result, arg, index) {
      result['p' + (index + 1)] = arg; //eslint-disable-line prefer-template
      return result;
    }, {});
    bi.error({
      errorName: errorName,
      errorCode: errorCode,
      severity: severity
    }, params);
  };

  var onerror = window.onerror;

  window.onerror = function (errorMsg, url, line, column, err) {
    var where = err && err.stack ? '' + err.stack : url;
    var href = window.location.href;

    _sendErrorOnce('JAVASCRIPT_ERROR', 111022, 'fatal', errorMsg, where, href); // JAVASCRIPT_ERROR from packages/core/src/main/bi/errors.js
    if (onerror) {
      return onerror.apply(this, arguments);
    }
  };

  if (window.console) {
    var _console = console,
        error = _console.error;

    if (error) {
      console.error = function () {
        var href = window.location.href;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _sendErrorOnce.apply(undefined, ['CONSOLE_ERROR', 111023, 'error', href].concat(args)); // CONSOLE_ERROR from packages/core/src/main/bi/errors.js
        return error.apply(this, args);
      };
    }
  }

  requirejs.onError = function (err) {
    // because ajv requires js-beautify synchronously even if does not use
    if (err.message && err.message.indexOf && err.message.indexOf('Module name "js-beautify" has not been loaded yet') === 0) {
      return;
    }
    var _err$requireModules = err.requireModules,
        requireModules = _err$requireModules === undefined ? [] : _err$requireModules,
        message = err.message,
        stack = err.stack,
        _err$errn = err.errn,
        errn = _err$errn === undefined ? 'REQUIREJS_ERROR' : _err$errn,
        _err$errc = err.errc,
        errc = _err$errc === undefined ? 111024 : _err$errc,
        _err$severity = err.severity,
        severity = _err$severity === undefined ? 'fatal' : _err$severity,
        requireType = err.requireType;

    var modules = requireModules.join(';');
    var what = stack ? '' + stack : message; //eslint-disable-line prefer-template
    var href = window.location.href;

    _sendErrorOnce(errn, errc, severity, what, modules, href, requireType); // REQUIREJS_ERROR from packages/core/src/main/bi/errors.js
  };
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = overrideScriptsLocationMapFromQuery;

var _replaceUrlVersion = __webpack_require__(2);

var _replaceUrlVersion2 = _interopRequireDefault(_replaceUrlVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function overrideScriptsLocationMapFromQuery(scriptsLocationMap, overrideParam) {
  overrideParam.split(',').filter(Boolean).forEach(function (keyValueString) {
    var pair = keyValueString.split(':');
    var urlOverride = (0, _replaceUrlVersion2.default)(scriptsLocationMap[pair[0]], pair[1]);
    if (urlOverride && scriptsLocationMap[pair[0]] !== urlOverride) {
      scriptsLocationMap[pair[0]] = urlOverride;
    }
  });
  return scriptsLocationMap;
}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = requirejs;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window, versions, getPloaderSantaConfig, local) {
  function getEditorRjsConfig(serviceTopology, editorModel, baseVersion, PackagesUtil) {
    var langsLocation = serviceTopology && serviceTopology.scriptsLocationMap['santa-langs'] || 'http://static.parastorage.com/services/santa-langs/1.194.0';
    var languageCode = editorModel && editorModel.languageCode || 'en';
    var langsUrl = (0, _joinURL2.default)(langsLocation, 'resources/santa-editor/bundles/_generated/santa_editor_' + languageCode + '.json');
    if (langsUrl.indexOf('http:') === 0) {
      langsUrl = [langsUrl, langsUrl.replace(/http/, 'https')];
    }

    var tpaGfppDataUrl = serviceTopology && serviceTopology.scriptsLocationMap['tpa-gfpp-data'] || 'http://static.parastorage.com/services/tpa-gfpp-data/1.5.0';
    var mmgrBaseUrl = serviceTopology ? serviceTopology.mediaManagerUrl : 'http://editor.wix.com/static/services/media-gallery-g5/1.81.0/';
    var scriptLocation = serviceTopology && serviceTopology.scriptsDomainUrl || 'http://static.parastorage.com/';

    var scriptsLocation = serviceTopology.scriptsDomainUrl;

    /**
     *  @type {function(pkg:string, path:string)}
     */
    var _unpkg = _rjsConfigUtils.unpkgOrNode.bind(null, versions, local);
    /**
     *  @type {function(pkg:string, min:string, debug:string)}
     */
    var _unpkgObj = _rjsConfigUtils.unpkgOrNodeObj.bind(null, versions, local);

    var thirdParty = _joinURL2.default.bind(null, scriptsLocation, 'services', 'third-party');
    var thirdObj = _rjsConfigUtils.thirdObjUrl.bind(null, scriptLocation);
    var ckeditor = _joinURL2.default.bind(null, scriptLocation, 'services', 'ck-editor');

    var basePublicUrl = serviceTopology.basePublicUrl || 'http://www.wix.com';
    var santaIde = _joinURL2.default.bind(null, basePublicUrl, '_partials', 'wix-code-ide');

    return {
      baseUrl: '',
      paths: {
        lodash: _unpkg('lodash', 'lodash.min'),
        jquery: (0, _rjsConfigUtils.unpkg)('jquery', '2.1.1', 'dist/jquery.min'),
        zepto: _unpkg('zepto', 'dist/zepto.min'),
        ckeditor: ckeditor('1.223.0/ckeditor'),
        wixmp: (0, _joinURL2.default)(serviceTopology.scriptsLocationMap['wixmp-sdk'], 'wixmp-sdk.amd'),
        color: thirdParty('color-convert/0.2.0/color.min'), // till 1.9.0, still no minified version on unpkg
        speakingurl: thirdParty('speakingurl/speakingurl.min'),
        keyboardMaster: thirdObj('keymaster', '1.6.3', 'keymaster.min', 'keymaster'), // no minified versions on unpkg
        react: _unpkgObj('react', 'dist/react-with-addons.min', 'dist/react-with-addons'),
        reactDOM: _unpkgObj('react-dom', 'dist/react-dom.min', 'dist/react-dom'),
        'prop-types': _unpkgObj('prop-types', 'prop-types.min', 'prop-types'),
        'create-react-class': (0, _rjsConfigUtils.unpkgObj)('create-react-class', '15.6.0-rc.0', 'create-react-class.min', 'create-react-class'),
        langs: langsUrl,
        mediaFrame: (0, _joinURL2.default)(mmgrBaseUrl, 'scripts/media-frame'),
        aviary: thirdParty('aviary/3.1.0.243/js/feather'), //no aviary on unpkg
        facebook: ['//connect.facebook.net/en_US/all', 'js/vendor/facebook/facebook.min'],
        pms: 'js/modules/PMS',
        jasmine: thirdParty('jasmine/2.1.3/jasmine'),
        'jasmine-html': thirdParty('jasmine/2.1.3/jasmine-html'), //file doesn't exist on unpkg
        'jasmine-boot': thirdParty('jasmine/2.1.3/jasmine-boot'), //file doesn't exist on unpkg
        bluebird: _unpkg('bluebird', 'js/browser/bluebird.min'),
        plugins: 'js/plugins/bundle/plugins.bundle',
        santaIde: {
          min: santaIde(versions.santaIde + '/code_edit/built-codeEdit.min'),
          source: santaIde(versions.santaIde + '/code_edit/built-codeEdit')
        },
        'redux-immutablejs': thirdParty('redux-immutablejs/0.0.7/redux-immutablejs.min'), //no minified version on unpkg
        immutable: _unpkgObj('immutable', 'dist/immutable.min', 'dist/immutable'),
        ReactProxy: 'js/vendor/ReactProxy',
        io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
        hot: '../node_modules/santa-utils/common/hot/listener', //only used in dev, so no unpkg
        patcher: '../node_modules/santa-utils/common/hot/patcher', //only used in dev, so no unpkg
        'wix-fullstory-loader': 'node_modules/wix-fullstory-loader/dist/statics/app.bundle',
        //'wix-fullstory-loader': _unpkg('wix-fullstory-loader', 'dist/statics/app.bundle'), //wix-full-storyloader isn't an editor dep
        'fedops-logger': 'node_modules/fedops-logger/dist/statics/fedops-logger-module.bundle.min',
        pmrpc: (0, _rjsConfigUtils.unpkg)('pm-rpc', '1.0.7', 'build/pm-rpc.min'),
        tpaGfppData: (0, _joinURL2.default)(tpaGfppDataUrl, '/data/tpa-gfpp-data.min'),
        baseUILib: _unpkg('wix-base-ui', 'dist/base-ui'),
        wixRichText: _unpkgObj('wix-richtext', 'dist/bundleWixRichText', 'debug/bundleWixRichText'),
        TweenMax: thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
        TweenLite: thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
        TimelineMax: thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
        ScrollToPlugin: thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/ScrollToPlugin.min', 'uncompressed/plugins/ScrollToPlugin'),
        DrawSVGPlugin: thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/DrawSVGPlugin.min', 'uncompressed/plugins/DrawSVGPlugin'),
        MorphSVGPlugin: thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/MorphSVGPlugin.min', 'uncompressed/plugins/MorphSVGPlugin'),
        Draggable: thirdObj('tweenmax', versions.tweenmax, 'minified/utils/Draggable.min', 'uncompressed/utils/Draggable'),
        addPanelSectionsDA: _unpkg('editor-add-panel', 'dist/addPanelSectionsDA'),
        addPanelSectionsDE: _unpkg('editor-add-panel', 'dist/addPanelSectionsDE'),
        addPanelSectionsEN: _unpkg('editor-add-panel', 'dist/addPanelSectionsEN'),
        addPanelSectionsES: _unpkg('editor-add-panel', 'dist/addPanelSectionsES'),
        addPanelSectionsFR: _unpkg('editor-add-panel', 'dist/addPanelSectionsFR'),
        addPanelSectionsIT: _unpkg('editor-add-panel', 'dist/addPanelSectionsIT'),
        addPanelSectionsJA: _unpkg('editor-add-panel', 'dist/addPanelSectionsJA'),
        addPanelSectionsKO: _unpkg('editor-add-panel', 'dist/addPanelSectionsKO'),
        addPanelSectionsNL: _unpkg('editor-add-panel', 'dist/addPanelSectionsNL'),
        addPanelSectionsNO: _unpkg('editor-add-panel', 'dist/addPanelSectionsNO'),
        addPanelSectionsPL: _unpkg('editor-add-panel', 'dist/addPanelSectionsPL'),
        addPanelSectionsPT: _unpkg('editor-add-panel', 'dist/addPanelSectionsPT'),
        addPanelSectionsRU: _unpkg('editor-add-panel', 'dist/addPanelSectionsRU'),
        addPanelSectionsSV: _unpkg('editor-add-panel', 'dist/addPanelSectionsSV'),
        addPanelSectionsTR: _unpkg('editor-add-panel', 'dist/addPanelSectionsTR'),
        addPanel: _unpkg('editor-add-panel', 'dist/addPanel'),
        coreMultilingual: _unpkg('santa-multilingual', 'dist/languages'),
        coreUtilsLib: _unpkg('santa-core-utils', 'dist/coreUtils'),
        reduxLibs: _unpkg('redux-libs', 'dist/redux-libs'),
        imageClientApi: _unpkg('santa-core-utils', 'dist/imageClientApi'),
        wixImmutable: _unpkg('santa-core-utils', 'dist/wixImmutable'),
        'ag-grid': (0, _rjsConfigUtils.unpkgObj)('ag-grid', '6.2.1', 'dist/ag-grid.min', 'dist/ag-grid')
      },
      packages: ['platformIntegrationEditor', 'tpaIntegrationEditor'].map(function (packageName) {
        return {
          name: packageName,
          main: packageName,
          location: (0, _getIntegrationPath2.default)(packageName, window.editorBase)
        };
      }),
      bundles: {
        plugins: ['json', 'domReady', 'experiment', 'pLoader']
      },
      shim: {
        color: { exports: 'Color' },
        lodash: { exports: '_' },
        jquery: { exports: '$' },
        keyboardMaster: { exports: 'key' },
        mediaFrame: { exports: 'MediaFrame', deps: ['jquery'] },
        aviary: { exports: 'featherEditor' },
        facebook: { exports: 'FB' },
        'jasmine-html': { deps: ['jasmine'] },
        'jasmine-boot': { deps: ['jasmine', 'jasmine-html'] },
        bluebird: { exports: 'bluebird' },
        ReactProxy: {
          deps: ['react'],
          exports: 'ReactProxy'
        }
      },
      map: {
        '*': {
          'react/addons': 'react'
        }
      },
      pLoader: {
        santa: getPloaderSantaConfig(serviceTopology, baseVersion, PackagesUtil)
      },
      jsx: {
        baseDefines: { lodash: '_', react: 'React' },
        fileExtension: '.html'
      },
      waitSeconds: 0
    };
  }

  return getEditorRjsConfig;
};

var _rjsConfigUtils = __webpack_require__(17);

var _getIntegrationPath = __webpack_require__(18);

var _getIntegrationPath2 = _interopRequireDefault(_getIntegrationPath);

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeObj = exports.node = exports.third = exports.thirdObjUrl = exports.unpkgObj = exports.unpkg = exports.vendorOrThirdPartyObj = exports.vendorOrThirdParty = exports.unpkgOrNodeObj = exports.unpkgOrNode = undefined;

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * builds an unpkg url e.g.
 * https://static.parastorage.com/unpkg/lodash@4.17.4/lodash.min.js
 * https://unpkg.parastorage.com/wix-base-ui@2.192.0/dist/base-ui.js
 * @param {string} pkg
 * @param {string} v
 * @param {string} p
 * @returns {string}
 */
function unpkg(pkg, v, p) {
  return '//static.parastorage.com/unpkg/' + pkg + '@' + v + '/' + p;
  // return `//unpkg.parastorage.com/${pkg}@${v}/${p}`
}

/**
 * @param {string} pkg
 * @param {string} v
 * @param {string} min
 * @param {string} debug
 * @returns {{min: string, source: string}}
 */
function unpkgObj(pkg, v, min, debug) {
  return {
    min: unpkg(pkg, v, min),
    source: unpkg(pkg, v, debug)
  };
}

/**
 * @param {string} scriptLocation
 * @param {string} pkg
 * @param {string} v
 * @param {string} min
 * @param {string} debug
 * @returns {{min: url, source: url}}
 */
function thirdObjUrl(scriptLocation, pkg, v, min, debug) {
  return {
    min: third(scriptLocation, pkg, v, min),
    source: third(scriptLocation, pkg, v, debug)
  };
}

/**
 * @param {string} v
 * @param {string} name
 */
function check(v, name) {
  if (typeof v === 'undefined') {
    throw new Error('error ' + name + ' is \'' + v + '\'');
  }
}

/**
 * @param {string} scriptsLocation
 * @param {string} pkg
 * @param {string} version
 * @param {string} path
 * @returns {url}
 */
function third(scriptsLocation, pkg, version, path) {
  check(scriptsLocation, 'scriptsLocation');
  check(pkg, 'pkg');
  check(version, 'version');
  check(path, 'path');
  return (0, _joinURL2.default)(scriptsLocation, 'services', 'third-party', pkg, version, path);
}

// function isLocalSource(window, name) {
//   return isLocal(getQueryUtils(window).getParameterByName('ReactSource'))
// }

/**
 *
 * @param {string} m
 * @param {string} p
 * @returns {string}
 */
function node(m, p) {
  return 'node_modules/' + m + '/' + p;
}

/**
 * @param {*} versions
 * @param {boolean} local
 * @param {string} m
 * @param {string} p
 * @returns {string}
 */
function unpkgOrNode(versions, local, m, p) {
  return local ? node(m, p) : unpkg(m, versions[m], p);
}

/**
 * @param {*} versions
 * @param {boolean} local
 * @param {string} m
 * @param {string} min
 * @param {string} debug
 * @returns {{min: string, source: string}}
 */
function unpkgOrNodeObj(versions, local, m, min, debug) {
  return local ? nodeObj(m, min, debug) : unpkgObj(m, versions[m], min, debug);
}

/**
 * @param {string} scriptsLocation
 * @param {boolean} local
 * @param {string} pkg
 * @param {string} v
 * @param {string} p
 * @returns {url}
 */
function vendorOrThirdParty(scriptsLocation, local, pkg, v, p) {
  return local ? jsVendor(pkg, v, p) : third(scriptsLocation, pkg, v, p);
}

/**
 * @param {string} scriptsLocation
 * @param {boolean} local
 * @param {string} pkg
 * @param {string} v
 * @param min
 * @param debug
 * @returns {url}
 */
function vendorOrThirdPartyObj(scriptsLocation, local, pkg, v, min, debug) {
  return local ? jsVendor(pkg, v, min) : thirdObjUrl(scriptsLocation, pkg, v, min, debug);
}

/**
 * @param {string} pkg
 * @param {string} v
 * @param {string} p
 * @returns {url}
 */
function jsVendor(pkg, v, p) {
  return (0, _joinURL2.default)('js/third-party-modules', pkg, v, p);
}

/**
 * @param {string} m
 * @param {string} min
 * @param {string} debug
 * @returns {{min: string, source: string}}
 */
function nodeObj(m, min, debug) {
  return { min: node(m, min), source: node(m, debug) };
}

exports.unpkgOrNode = unpkgOrNode;
exports.unpkgOrNodeObj = unpkgOrNodeObj;
exports.vendorOrThirdParty = vendorOrThirdParty;
exports.vendorOrThirdPartyObj = vendorOrThirdPartyObj;
exports.unpkg = unpkg;
exports.unpkgObj = unpkgObj;
exports.thirdObjUrl = thirdObjUrl;
exports.third = third;
exports.node = node;
exports.nodeObj = nodeObj;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIntegrationPath;

var _isLocal = __webpack_require__(1);

var _isLocal2 = _interopRequireDefault(_isLocal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var packageToFolder = {
  tpaIntegration: 'Santa-Integration-Protractor',
  wixCodeIntegration: 'js-wixcode-integration',
  viewerIntegration: 'viewer-integration',
  platformIntegrationEditor: 'js-platform-integration',
  tpaIntegrationEditor: 'Santa-Editor-Integration-Protractor' };

function getIntegrationPath(packageName, baseArtifact) {
  var integrationBasePath = (0, _isLocal2.default)(baseArtifact) ? '//localhost:4578' : '//s3.amazonaws.com/integration-tests-statics/' + packageToFolder[packageName] + '/SNAPSHOT/runners';

  return integrationBasePath + '/' + packageName + '/src/main';
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = runEditor;
function runEditor(window, packagesStructure, requirejs, editorModel, queryUtil, config) {
  var packagesArr = ['symbols', 'rEditor', 'compPanels', 'core', 'wixStore', 'tpa', 'util', 'blog', 'wixBookings', 'jquery', 'react', 'reactDOM', 'lodash', 'aviary', 'superAppMenuInfra', 'savePublish', 'panels', 'experiment', 'staticAssets', 'pLoader', 'textControls', 'mediaFrame', 'keyboardMaster', 'baseUI', 'uiAnimations', 'panelUtils', 'mediaServices', 'color', 'pms', 'databaseEditor', 'json', 'gfppData', 'backgroundPresets', 'styles', 'pagesMenu', 'userPreferences', 'popups', 'pLoader!santa:skins', 'pLoader!santa:documentServices'];

  if (queryUtil.isParameterTrue('isqa')) {
    packagesArr.push('pLoader!santa:qaAutomation', 'debugTools');
  }
  if (queryUtil.isParameterTrue('isTpaIntegration')) {
    packagesArr.push('tpaIntegrationEditor', 'jasmine', 'jasmine-html');
  }
  if (queryUtil.isParameterTrue('isUiLibIntegration')) {
    packagesArr.push('uiLibIntegrationEditor', 'jasmine', 'jasmine-html');
  }
  if (queryUtil.isParameterTrue('isPlatformIntegration')) {
    packagesArr.push('platform', 'platformIntegrationEditor', 'jasmine', 'jasmine-html');
  }

  var onError = errorHandler;

  var prefetch = window.isPrefetchMode || window.location.pathname.indexOf('prefetch') > 0 || queryUtil.isParameterTrue('prefetch');

  var languagePackageName = void 0;
  if (prefetch) {
    packagesArr.push('addPanelData', 'addPanelInfra', 'addPanel', 'addPanelDataConsts', 'addPanelSectionsEN');

    var languageCode = window.editorModel && window.editorModel.languageCode;
    languagePackageName = languageCode && 'addPanelSections' + languageCode.toUpperCase();
    var existsInPackagesStructure = packagesStructure.indexOf(languagePackageName) !== -1;
    var existsInPackagesArr = packagesArr.indexOf(languagePackageName) !== -1;
    var isSupportedAddPanelLanguage = !!config.paths[languagePackageName];
    if (!existsInPackagesStructure && !existsInPackagesArr && isSupportedAddPanelLanguage) {
      packagesArr.push(languagePackageName);
    }

    // Preload scripts for caching
    if (window.define) {
      onError = function onError() {};
      var plugins = {
        pLoader: true,
        json: true,
        text: true,
        experiment: true
      };
      var dummy = function dummy() {
        return {};
      };
      var _define = window.define;
      window.define = function (name) {
        var args = Array.apply(null, arguments);
        if (!plugins.hasOwnProperty(name) && name !== 'jquery') {
          for (var i = 1; i < args.length; ++i) {
            if (typeof args[i] === 'function') {
              args[i] = dummy;
            }
          }
        }
        return _define.apply(this, args);
      };
      window.define.amd = _define.amd;
    }
  }

  if (typeof Promise !== 'undefined') {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return Promise;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); //eslint-disable-line no-undef
  } else {
    packagesArr.push('bluebird');
  }

  requirejs(packagesArr, function () {
    if (prefetch) {
      return;
    }

    function buildFunctionParametersObject(_pkgs, args) {
      return _pkgs.reduce(function (result, pkg, index) {
        result[pkg.replace(/^.*:/, '')] = args[index];
        return result;
      }, {});
    }
    var p = buildFunctionParametersObject(packagesArr, arguments);

    if (p.bluebird) {
      window.Promise = p.bluebird;
    }

    if (languagePackageName) {
      p.addPanel.sections.applyTranslatedSections(p[languagePackageName]);
    }

    p.rEditor.editorMain.start(p);
  }, onError);

  function errorHandler(err) {
    if (!config.urlArgs) {
      if (err.requireModules) {
        err.requireModules.forEach(function (module) {
          requirejs.undef(module);
        });
      }
      config.urlArgs = 'c=' + Date.now();
      requirejs.config(config);
      requirejs(packagesArr, function () {
        err.errn = 'REQUIREJS_RETRY_ERROR';
        err.errc = 111025;
        err.severity = 10;
        requirejs.onError(err);
      }, function (error) {
        requirejs.onError(error);
      });
    }
  }
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window) {
  function isAvailable(name) {
    try {
      var unique = 'testStorage' + Date.now();
      var st = window[name];
      st.setItem(unique, unique);
      var value = st.getItem(unique);
      st.removeItem(unique);
      if (value !== unique) {
        throw 'not equal'; //eslint-disable-line no-throw-literal
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  var storage = void 0;
  if (isAvailable('localStorage')) {
    storage = window.localStorage;
  } else if (isAvailable('sessionStorage')) {
    storage = window.sessionStorage;
  } else {
    storage = {
      setItem: function setItem() {},
      getItem: function getItem() {},
      removeItem: function removeItem() {}
    };
  }

  return {
    save: function save(key, value) {
      storage.setItem(key, value);
    },
    load: function load(key) {
      return storage.getItem(key);
    },
    remove: function remove(key) {
      storage.removeItem(key);
    }
  };
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {"versions":{"lodash":"4.17.4","react":"15.5.4","react-dom":"15.5.4","prop-types":"15.5.7","immutable":"3.6.2","bluebird":"3.5.1","zepto":"1.2.0","redux-libs":"1.52.0","pmrpc":"1.30.0","tweenmax":"1.19.0","santaIde":"1.24.0","wix-base-ui":"2.409.0","editor-add-panel":"1.166.0","santa-core-utils":"1.173.0","wix-richtext":"2.298.0","santa-multilingual":"1.69.0"},"packages":["addPanelData","addPanelDataConsts","addPanelInfra","advancedStylePanel","backgroundPresets","baseUI","blog","boxSlideshow","columnsControls","compPanels","constants","core","customizeDesignDataPanel","databaseEditor","debugTools","designPanel","designPanelUtils","editorEventRegistry","editorHints","firstTimeExperience","firstTimePanelsComponents","gfppData","helpIds","higherOrderComponents","imageCrop","mediaServices","mobileEditor","multilingual","pageSettingsPanel","pages","pagesMenu","panelUtils","panels","platform","platformPanels","popups","rEditor","santaPreview","savePublish","shoutOut","stateManagement","staticAssets","styles","superAppMenuInfra","symbols","testUtils","textControls","topBar","tpa","tpaPanels","uiAnimations","uiConstants","userPreferences","util","videoSearch","wixBookings","wixCode","wixStore"]}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main-r.min.js